import React from 'react';
import {withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {inject, observer} from 'mobx-react';

import * as R from 'ramda';

import NavDropdown from 'react-bootstrap/NavDropdown';
import {ReactComponent as RussianFlag} from 'Assets/icons/russian-flag.svg';
import {ReactComponent as KyrgyzFlag} from 'Assets/icons/kyrgyz-flag.svg';
import {ReactComponent as EnglishFlag} from 'Assets/icons/english-flag.svg';

import {
  RU_RU,
  KG_KG,
  EN_US,
  LANGUAGES,
} from 'Internal';

import './DefaultHeader.scss';

class LangNav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lang: LANGUAGES?.filter(lang => lang.code === this.props.i18n.language)?.[0]?.name,
    };
  }

  changeLang = (lang) => {
    const {i18n} = this.props;

    i18n.changeLanguage(lang);
    window.location.reload();
  }

  render() {
    const {t} = this.props;

    const {lang} = this.state;

    let iconLang = null;

    if (lang === 'Кыргызча') {
      iconLang = <KyrgyzFlag style={{marginTop: '-2px', marginRight: '5px'}}/>;
    } else if (lang === 'Русский') {
      iconLang = <RussianFlag style={{marginTop: '-2px', marginRight: '5px'}}/>;
    } else {
      iconLang =  <EnglishFlag style={{marginTop: '-2px', marginRight: '5px'}}/>;
    }

    return (
      <NavDropdown
        id="user-nav-dropdown"
        title={<div style={{display: 'inline-block'}}> {iconLang} {lang} </div>}
        alignRight
        style={{color: '#333333'}}
      >
        <NavDropdown.Item
          onClick={() => this.changeLang(RU_RU)}
        >
          <RussianFlag className="mr-3" style={{marginTop: '-2px'}}/>
          {t('Russian')}
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => this.changeLang(EN_US)}
        >
          <EnglishFlag className="mr-3" style={{marginTop: '-2px'}}/>
          {t('English')}
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => this.changeLang(KG_KG)}
        >
          <KyrgyzFlag className="mr-3" style={{marginTop: '-2px'}}/>
          {t('Kyrgyz')}
        </NavDropdown.Item>
      </NavDropdown>
    );
  }
}

function applyContext(WrappedComponent) {
  const injectContext = R.pipe(
    observer,
    inject('stores'),
    withRouter,
    withTranslation(['header']),
  );
  return injectContext(WrappedComponent);
}

export default applyContext(LangNav);
